export default __webpack_public_path__ + "static/media/index.d67f1d52.less";